import __vue_component__ from '../Select/Select.vue.js';
import __vue_component__$1 from '../Form/InlineEdit.vue.js';

//
var script = {
  name: 'CustomSingleSelectEditableRenderer',
  components: {
    Select: __vue_component__,
    InlineEdit: __vue_component__$1
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'right'
    },
    value: {
      type: [String, Object],
      default: ''
    },
    allowedValues: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    normalizer: {
      type: Function,
      default: value => ({
        id: value,
        label: value,
        value,
        disabled: false
      })
    },
    confirm: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      options: this.allowedValues
    };
  },

  methods: {
    onSaveRequested(option, callback) {
      const value = option || '';
      this.$emit('save-requested', value, callback);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/CustomSingleSelectEditableRenderer.vue_rollup-plugin-vue=script.js